import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { esignActions, esignSelectors } from 'src/app/root-store/esign-store';
import { FolderFlatNode, TemplateFolder } from '../models/template-folder.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';

@UntilDestroy()
@Component({
    selector: 'nova-template-folder-list',
    templateUrl: './template-folder-list.component.html',
    styleUrls: ['./template-folder-list.component.scss']
})
export class TemplateFolderListComponent implements OnInit {
    private readonly _transformer = (node: TemplateFolder, level: number) => {
        return {
            expandable: !!node.subFolders && node.subFolders.length > 0,
            name: node.name,
            level: level,
            id: node.id
        };
    };

    treeControl = new FlatTreeControl<FolderFlatNode>(
        (node) => node.level,
        (node) => node.expandable
    );

    treeFlattener = new MatTreeFlattener(
        this._transformer,
        (node) => node.level,
        (node) => node.expandable,
        (node) => node.subFolders
    );

    dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    activeNode: FolderFlatNode;

    constructor(private readonly _store: Store) {}

    ngOnInit(): void {
        this._store.dispatch(esignActions.EsignActions.getTemplateFolders({ forceRefresh: false }));
        this._store
            .select(esignSelectors.selectTemplateFolders)
            .pipe(
                filter((folders) => !isEmpty(folders)),
                untilDestroyed(this)
            )
            .subscribe((folders) => {
                this.dataSource.data = folders;
            });
        this._store
            .select(esignSelectors.selectSelectedFolder)
            .pipe(untilDestroyed(this))
            .subscribe((folderId) => {
                if (folderId === null) {
                    this.activeNode = null;
                }
            });
    }

    hasChild = (_: number, node: FolderFlatNode) => node.expandable;

    folderClick(node: FolderFlatNode): void {
        this.activeNode = node;
        this._store.dispatch(esignActions.EsignActions.setSelectedFolder({ folderId: node.id }));
    }
}
